import produce from 'immer';
import { ReducerAction } from 'store/modules/types';

// TYPES
import { Types, ExcluirLocalidadesRelacionadas } from './types';

export const INITIAL_STATE: ExcluirLocalidadesRelacionadas = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): ExcluirLocalidadesRelacionadas {
	return produce(state, draft => {
		switch (action.type) {
			case Types.EXCLUIR_LOCALIDADES_RELACIONADAS: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.EXCLUIR_LOCALIDADES_RELACIONADAS_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.EXCLUIR_LOCALIDADES_RELACIONADAS_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.EXCLUIR_LOCALIDADES_RELACIONADAS_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
	});
}
